import * as React from 'react';
import { Link } from 'react-router-dom';
import { UserProfileImage } from 'header/userprofile/UserProfileImage';
import { langutil } from 'language/langutil';
import svcs from 'services';
import { useLoginInfo } from 'hooks/useLoginInfo';
import { i18ntrans } from 'language/i18nkey';
import { useZstdHeader } from 'header/header/useZstdHeader';
import { useZstdInfo } from 'zstd/useZstdInfo';

type Props = {};
export const RenderUserInfo = (props: Props) => {
  const { country, lang } = langutil.splitLangCode(svcs.svcLang.lang());
  const loginInfo = useLoginInfo();
  const techPoint = loginInfo?.techPoint;
  const trans = (key: string): string => {
    return i18ntrans.header(key as any);
  };
  const { alertAlarmCount } = useZstdHeader();
  const { setShowUserPopup } = useZstdInfo();
  const getTechPointCls = (techPoint: number) => {
    if (techPoint >= 1000) return 'first';
    else if (techPoint >= 500) return 'second';
    else if (techPoint >= 100) return 'third';
    else if (techPoint >= 30) return 'fourth';
    return 'fifth';
  };
  return (
    <div className={'user_info_div'}>
      <Link
        to={`/${country}/${lang}/myPage`}
        state={{ id: loginInfo?.userId }}
        onClick={() => {
          setShowUserPopup(false);
        }}
      >
        <div className={'user_info'}>
          <UserProfileImage headerStyle={'userInfo'} loginInfo={loginInfo} />
          <div>
            <p className={'name'}>
              {loginInfo?.nickname}
              <span className={`${getTechPointCls(techPoint)}`}>{techPoint}</span>
            </p>
            {/*<p className={"name_alt"}>{this.state.loggedInNickname}</p>*/}
            <p className={'my-alarm-txt'}>
              {trans('I18N_TITLE_ALARMS')} <span className="alarm-counter">+{alertAlarmCount}</span>
            </p>
          </div>

          {/*{gconf.showPublic ? this.renderUserLevel() : <p className={"user_level"}>{this.getTranslation("I18N_TITLE_LEVEL")}</p>}
        관리자는 삭제 요청*/}
        </div>
      </Link>
    </div>
  );
};
